import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { Collapse } from 'react-collapse'

import {
    saveTaskNote,
    setModal,
} from 'actions'

// Styles
import colors from 'styles/_exports.module.scss';
import "./ProtocolTask.scss";

//Icons
import IconNotebook from 'components/icons/notebook-solid';
import IconHexagon from 'components/icons/hexagon-solid';
import IconEdit from 'components/icons/pencil-solid';

import { withTranslation } from 'react-i18next'
import {LogEvent} from '@learningblocks/shared-components/lib/EventLogger'; 

class ProtocolTask extends Component {
    constructor(props) {
        super(props);

        this.state = {
            createNoteView: false,
            readNoteView: false,
            normalView: true,
            menuOpen: false,
            note: ''
        }
    }

    handleClick = (e) => {
      const domNode = ReactDOM.findDOMNode(this.node)

      if(domNode){
        if(domNode.contains(e.target)){
          //Click is inside component
          return;
        }
        // Click is outside component -- close the menu
        this.setState({
            menuOpen: false
        })
      }
    }

    componentDidUpdate(prevProps){
      if(this.props.page !== prevProps.page){
        this.setState({
          createNoteView: false,
          readNoteView: false,
          normalView: true,
          menuOpen: false,
          note: ''
        })
      }
    }

    componentWillMount(){
      document.body.addEventListener('mousedown', this.handleClick, false);
    }

    componentWillUnmount(){
      document.body.removeEventListener('mousedown', this.handleClick, false);
    }

    showNotesClicked = () => {
        this.setState({
            readNoteView: !this.state.readNoteView,
            menuOpen: false,
            createNoteView: false
        })
    }

    createNoteClicked = () => {
        this.setState({
            createNoteView: !this.state.createNoteView,
            menuOpen: false,
            readNoteView: false,
            note: ''
        })
    }

    toggleMenu = () => {
      this.setState({
          readNoteView: false,
          createNoteView: false,
          menuOpen: !this.state.menuOpen
      })
    }

    handleFormChange = (e) => {
      this.setState({
          note: e.target.value
      })
    }

    handleFormSubmit = (e) => {
      e.preventDefault();

      this.setState({
        menuOpen: false,
        createNoteView: false,
        note: ''
      });

      this.props.saveTaskNote(this.state.note, (this.props.page - 1), this.props.tIndex);
    }

  renderTaskModalBtn = () => {
    let btn = ''

    if(this.props.modal === undefined){
      return ""
    } else {
      //Choose type of button based on modal content
      if (this.props.modal.type === "countdown" && this.props.current) {
        //Render countdown button
        btn = (<button
          className={'showTimerInTaskBtn'}
          onClick={() => {
            this.props.setModal({
              display: true,
              type: "TASK_COUNTDOWN",
              size: "sm",
              connect: -1,
              data: this.props.modal
            });
          }}>
          {this.props.t("Start timer")}
        </button>)
      }
    }

    return btn
  }


  getAlphabetIndex = (index) => {
    if (index >= 26) {
      const upperIndex = Math.floor(index / 25);
      const delta = index - 25 * upperIndex;

      return (
        String.fromCharCode(96 + upperIndex) + String.fromCharCode(96 + delta)
      );
    }
    return String.fromCharCode(97 + index);
  };

  render() {

      return (
        <li className={"protocol-task" + ((this.props.current) ? " current-task" : "") + ((this.props.complete) ? " completed-task" : "")} tabIndex={0}>
          <div className="index">
            <IconHexagon
              style={{ color: ((this.props.current) ? "white" : ((this.props.complete) ? colors.navy3 : colors.navy1)), height: '29px' }}
            />
            <span style={{ color: ((this.props.current) ? colors.navy1 : "white") }}>
              {(this.props.complete) ? " " : this.props.t(String.fromCharCode(97 + this.props.tIndex))}
            </span>
          </div>

          <span aria-label={this.props.t(this.props.aria)} className="task-text">{this.props.t(this.props.task)}</span>
          <button className="anchor"
            onClick={this.showNotesClicked}
            style={{ display: (!this.state.readNoteView && this.props.notes.length > 0 ? "initial" : "none"), cursor: 'pointer' }}>
            <IconNotebook
              style={{ color: colors.charcoal1, height: '15px', top: '2px' }}
            />
          </button>

          {this.renderTaskModalBtn()}

          <div className="protocol-menu"
            ref={node => this.node = node}>
            <button
              className="toggle-menu anchor"
              onClick={this.createNoteClicked}
              aria-label={this.props.t("Notes. Select to view the options.")}
            >
              <IconEdit
                style={{ color: colors.navy1, height: '16px', top: '10px', right: '10px'}}
              />
            </button>
            {/* <Collapse
              isOpened={this.state.menuOpen}
              aria-hidden={!this.state.menuOpen}
              theme={{ collapse: 'collapse', content: 'collapse-content' }}
              style={{ position: 'absolute' }}
              springConfig={{ stiffness: 500, damping: 30 }}>

              <button
                className="anchor"
                onClick={this.createNoteClicked}
                tabIndex={(this.state.menuOpen) ? null : -1}>
                Add Note
              </button>
            </Collapse> */}
          </div>

          <Collapse
            isOpened={this.state.readNoteView}
            aria-hidden={!this.state.readNoteView}
            theme={{ collapse: 'collapse', content: 'collapse-content' }}
            springConfig={{ stiffness: 500, damping: 30 }}>
            <div className="notes-content">
              <div className="notes">
                <p>{this.props.t("Notes:")}</p>
                <ul>
                  {this.props.notes.map((note, index) => (
                    <p key={index}>{this.props.t(note)}</p>
                  ))}
                </ul>
              </div>
              <button
                className="anchor"
                onClick={this.showNotesClicked}
                tabIndex={(this.state.readNotesView) ? null : -1}>Hide</button>
            </div>
          </Collapse>
          <Collapse
            isOpened={this.state.createNoteView}
            aria-hidden={!this.state.createNoteView}
            style={{display: (!this.state.createNoteView)?"none": null}}>
            <form className="add-note-panel"
              onSubmit={(e) => { e.preventDefault() }}>
              <p>{this.props.t("Observations:")}</p>
              <textarea
                aria-label={this.props.t("Add observations text-entry field. Input text to add a note to this instruction.")}
                placeholder={this.props.t("Add observations")}
                onChange={this.handleFormChange}
                value={this.state.note}
                tabIndex={(this.state.createNoteView) ? null : -1} />
              <div className="btns">
                <button
                  aria-label={this.props.t("Cancel button. Select to discard changes you’ve made to your notes.")}
                  className="anchor"
                  onClick={this.createNoteClicked}
                  tabIndex={(this.state.createNoteView) ? null : -1}>{this.props.t("Cancel")}</button>
                <LogEvent
                  logEventProps={{
                    event_type: "sim_protocol_step_note created",
                    event_schema: "note",
                    note: this.state.note,
                    part_number: this.props.pIndex,
                    step_number: this.getAlphabetIndex(this.props.tIndex) 
                  }}
                  actionProps={{ onClick: { action: 'click' } }}
                  elementType="button"
                >
                  <button
                    aria-label={this.props.t("Save note button. Select to save changes you’ve made to your notes.")}
                    type="submit"
                    tabIndex={(this.state.createNoteView) ? null : -1}
                    onClick={this.handleFormSubmit}>{this.props.t("Save note")}</button>
                </LogEvent>
              </div>
            </form>
          </Collapse>
        </li>
      );
  }
}

ProtocolTask.defaultProps = {
    notes: []
};

const mapStateToProps = (state, ownProps) => {
    return {
        pIndex: ownProps.pIndex,
        tIndex: ownProps.tIndex,
        level: ownProps.level,
        page: ownProps.page,
        task: state.notebook.taskPages[ownProps.pIndex].tasks[ownProps.tIndex].levels[ownProps.level].task,
        action: state.notebook.taskPages[ownProps.pIndex].tasks[ownProps.tIndex].action,
        notes: state.notebook.taskPages[ownProps.pIndex].tasks[ownProps.tIndex].notes,
        criteria: state.notebook.taskPages[ownProps.pIndex].tasks[ownProps.tIndex].levels[ownProps.level].criteria,
        complete: state.notebook.taskPages[ownProps.pIndex].tasks[ownProps.tIndex].complete,
        current: state.notebook.taskPages[ownProps.pIndex].tasks[ownProps.tIndex].current,
        aria: state.notebook.taskPages[ownProps.pIndex].tasks[ownProps.tIndex].aria,
        modal: state.notebook.taskPages[ownProps.pIndex].tasks[ownProps.tIndex].levels[ownProps.level].modal,
    }
}

export default connect(mapStateToProps, {
    saveTaskNote,
    setModal,
})(withTranslation()(ProtocolTask));
